import { createSlice } from '@reduxjs/toolkit';

// Начальное состояние для tasks
const initialState = {
    items: [], // Список tasks (item)
    tasksLoaded: false, // Флаг: были ли задачи загружены/изменены
    tasksModified: false, // Флаг: были ли задачи изменены пользователем
    disabledDefaultTaskIds: [], // Дефолтные таски (is_locked=false), выключенные для этого промо
};

// Создание слайса для tasks
const tasksSlice = createSlice({
    name: 'tasks',
    initialState,
    reducers: {
        // Добавить новый task
        addTask: (state, action) => {
            state.items.push(action.payload);
            state.tasksModified = true;
        },
        // Удалить task по индексу
        removeTask: (state, action) => {
            state.items.splice(action.payload, 1);
            state.tasksModified = true;
        },
        // Обновить task по индексу
        updateTask: (state, action) => {
            const { index, task } = action.payload;
            if (state.items[index]) {
                state.items[index] = { ...state.items[index], ...task };
                state.tasksModified = true;
            }
        },
        // Очистить все tasks
        clearTasks: (state) => {
            state.items = [];
            state.tasksLoaded = false;
            state.tasksModified = false;
            state.disabledDefaultTaskIds = [];
        },
        // Вкл/выкл дефолтный таск для создаваемого промо
        toggleDefaultTask: (state, action) => {
            const id = Number(action.payload);
            if (state.disabledDefaultTaskIds.includes(id)) {
                state.disabledDefaultTaskIds = state.disabledDefaultTaskIds.filter((x) => x !== id);
            } else {
                state.disabledDefaultTaskIds.push(id);
            }
        },
        // Задать все tasks (например, при загрузке из API)
        setTasks: (state, action) => {
            state.items = action.payload;
            state.tasksLoaded = true;
        },
        // Keep only first N tasks when category max shrinks
        trimTasksToMax: (state, action) => {
            const max = Number(action.payload);
            if (!Number.isFinite(max) || max < 0) return;
            if (state.items.length > max) {
                state.items = state.items.slice(0, max);
                state.tasksModified = true;
            }
        },
        // Пометить задачи как загруженные (даже если пустой массив)
        setTasksLoaded: (state, action) => {
            state.tasksLoaded = action.payload;
        },
    },
});

export const { addTask, removeTask, updateTask, clearTasks, setTasks, trimTasksToMax, setTasksLoaded, toggleDefaultTask } = tasksSlice.actions;
export default tasksSlice;
